/* eslint-disable jsx-a11y/heading-has-content, class-methods-use-this */

// node modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, propTypes, reduxForm, reset } from 'redux-form';
import withStyles from 'isomorphic-style-loader/withStyles';

// app modules: actions
import addCollection from 'actions/user/addCollection';

// app modules: components
import { SelectField, InputField, TextareaField, validators } from 'components/Field';
import SpinnerButton from 'components/SpinnerButton';

// app modules: constants
import { FORMS } from 'constants/view';
import { PRIVACY_OPTIONS } from 'constants/privacy';

// assets
import CssNewCollectionForm from './NewCollectionForm.scss';

class CollectionNew extends PureComponent {
  static propTypes = {
    ...propTypes,
    addCollection: PropTypes.func.isRequired,
    itemId: PropTypes.string,
    itemType: PropTypes.string,
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {
    itemId: null,
    itemType: null,
  };

  constructor(props) {
    super(props);

    this.validators = {
      minLength3: validators.minLength(3),
    };

    this.bound = {
      onSubmit: this.onSubmit.bind(this),
    };

    this.state = {
      loading: false,
    };
  }

  async onSubmit(values) {
    const { itemId, itemType } = this.props;
    this.setState({ loading: true });
    await this.props.addCollection({
      itemId,
      itemType,
      ...values,
      visibility: values.visibility || 'private',
    });
    this.setState({ loading: false });
    this.props.onClose();
    this.props.reset(FORMS.COLLECTION_NEW);
  }

  render() {
    const { loading } = this.state;
    const { handleSubmit } = this.props;

    return (
      <form onSubmit={handleSubmit(this.bound.onSubmit)} className="new-collection-form">
        <Field
          component={InputField}
          label="Collection name"
          name="name"
          validate={[validators.required, this.validators.minLength3]}
        />
        <Field label="Description (optional)" name="description" component={TextareaField} />
        <Field
          label="Who can view?"
          name="visibility"
          component={SelectField}
          initialValue="private"
          options={PRIVACY_OPTIONS}
        />

        <footer className="modal__footer">
          <SpinnerButton
            loading={loading}
            onClick={handleSubmit(this.bound.onSubmit)}
            text="Create collection"
            type="submit"
          />
        </footer>
      </form>
    );
  }
}

const mapDispatchToProps = {
  addCollection,
  reset,
};

export default reduxForm({
  form: FORMS.COLLECTION_NEW,
})(
  connect(
    null,
    mapDispatchToProps,
  )(withStyles(CssNewCollectionForm)(CollectionNew)),
);
